export function formatScore(score: number): string {
  return score.toFixed(1).replace('.', ',');
}

// Date formatting for the beta-users admin list (design: Beta Users
// Admin). Distinct from `formatRelativeTime` (shelf/feed copy), which has
// its own spec — don't merge them.
export function formatAddedDate(isoDate: string): string {
  const date = new Date(isoDate);
  if (!Number.isFinite(date.getTime())) return isoDate;

  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const dayMs = 24 * 60 * 60 * 1000;
  // `new Date(Date.now())` (not the zero-arg form) so tests can pin time
  // by spying on Date.now, matching formatRelativeTime's test seam.
  const diffDays = Math.floor((startOfDay(new Date(Date.now())) - startOfDay(date)) / dayMs);

  if (diffDays <= 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${String(diffDays)}d ago`;
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatRelativeTime(isoDate: string): string {
  const date = new Date(isoDate);
  const then = date.getTime();
  if (!Number.isFinite(then)) return isoDate;

  const now = Date.now();
  const seconds = Math.max(0, Math.floor((now - then) / 1000));

  if (seconds < 60) return 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${String(minutes)}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${String(hours)}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${String(days)}d ago`;

  const currentYear = new Date(now).getFullYear();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  return date.getFullYear() === currentYear
    ? `${month} ${String(day)}`
    : `${month} ${String(day)}, ${String(date.getFullYear())}`;
}
